import { ExtranetWrapper } from '../../components/extranet/ExtranetWrapper'

export const ServicesView = () => {
  return <ExtranetWrapper />
}
